import _ from 'lodash';
import React from 'react';
import styled from 'styled-components';
import propTypes from '../../common/prop-types';
import { SectionDetails } from '../../../shared/sectionable/styles';
import withKeyInfo from './hoc-single-info';

const gap = 32;
const Container = styled(SectionDetails)`
  flex-direction: row;
  ${props => (props.theme.isLarge ? `
    & > section {
      flex-basis: 50%;
    }

    & > section:first-child {
      margin-right: ${gap}px;
    }
  ` : `
    flex-wrap: wrap;
    & > section {
      flex-basis: 100%;
    }

    & > section:first-child {
      margin-bottom: ${gap}px;
    }
  `)};

  & > section > *:not(:last-child) {
    margin-bottom: ${gap}px;
  }
`;

export default function Details({ fund }) {
  const { fundType, apirCode } = fund;
  const isETF = fundType === 'ETF';
  const showApir = !isETF && apirCode;
  const keys = [
    [
      'name', 'fundAssetClass', 'currency', 'minimumInvestment',
      'investmentHorizon', 'geographicalFocus',
      showApir ? 'apirCode' : 'stockCode',
      'isin',
    ],
    ['fundSize', 'legalStructure', 'domicile', 'inceptionDate', 'fundType', 'moreInfo'],
  ];

  return (
    <Container>
      {_.times(2).map(index => (
        <section key={index}>
          {keys[index].map(key => {
            const Component = withKeyInfo(key);
            return <Component key={key} fund={fund} />;
          })}
        </section>
      ))}
    </Container>
  );
}

/* eslint-disable-next-line react/require-default-props */
Details.propTypes = { fund: propTypes.fund };
